export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registration-bonus.vue?vue&type=template&id=52c0eddf"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/sport-banners/registration-bonus.vue?vue&type=template&id=52c0eddf
// module id = OcpQ
// module chunks = 0